module.exports = __webpack_public_path__ + "img/vilagos-alap1.57a308af.png";